<script>

    export let label = null
    export let checked = false

    const uid = `toggle-${Math.random().toString(36).slice(2, 9)}`

</script>

<style>

    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
    }

    input[type="checkbox"]:focus:not(:focus-visible) {
        outline: 0;
    }

    input[type="checkbox"]:focus-visible {
        outline: none;
        box-shadow: var(--focus-ring);
        border-radius: var(--radius-toggle);
    }

    .toggle {
        height: 22px;
        width: 42px;
        border-radius: var(--radius-toggle);
        display: inline-block;
        position: relative;
        margin: 0;
        border: solid 2px hsl(0, 0%, 80%);
        background: hsl(0, 0%, 80%);
        transition: all .2s ease;
    }

    .toggle:after {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: hsl(0, 0%, 97%);
        box-shadow: 0 1px 2px rgba(44,44,44,.2);
        transition: all .2s cubic-bezier(.5,.1,.75,1.35);
    }

    .toggle:checked {
        border-color: var(--color-primary);
        background: var(--color-primary);
    }

    .toggle:checked:after {
        transform: translatex(20px);
    }

</style>

<div class="items-start" on:click>
    <input id={uid} bind:checked type="checkbox" class="toggle" on:change>
    {#if label}
        <label for={uid} class="label space-left">{ label }</label>
    {/if}
</div>
